import React, {useMemo} from "react";
import useAnimalSingleInfo from "../ideal-charts/useAnimalSingleInfo";
import useSingleAnimalDomain from "../ideal-charts/useSingleAnimalDomain";
import {makeGetWeightingEvents} from "../../../selectors/animalDocumentsSelectors";
import {useSelector} from "react-redux";
import {localMomentToUTC} from "../../../utils/DateTimeUtils";
import WeightingContainer from "./WeightingContainer";
import {shouldIncludeInWeightingChart} from "../ideal-charts/utils/eventFilters";

export default function WeightingSingleChart() {
    const animalInfo = useAnimalSingleInfo();

    const domain = useSingleAnimalDomain();

    const getWeightingEvents = useMemo(() => makeGetWeightingEvents(), []);

    const weightingEvents = useSelector(getWeightingEvents);

    const weightDict = useMemo(() => {
        const dictionary = {};
        for (const event of weightingEvents) {
            if (!shouldIncludeInWeightingChart(event)) {
                continue;
            }
            const utcTIME = +localMomentToUTC(event?.EvTime).startOf("day");
            if (!dictionary[utcTIME]) dictionary[utcTIME] = [];
            dictionary[utcTIME].push({
                [event.EvCode]: event?.EvData?.Weight || 0,
                weight: event?.EvData?.Weight || 0,
                Files: event?.EvData?.Files || [],
                AnmCnt: event?.EvData?.AnmCnt || event?.AnmCnt || 1,
                AnmID: event?.AnmID,
                PlcmntID: event?.EvData?.PlcmntID,
            });
        }
        return dictionary;
    }, [weightingEvents]);

    const weightingProps = useMemo(() => {
        return {
            weightDict,
            chartDomain: domain,
            ...animalInfo,
        };
    }, [weightDict, domain, animalInfo]);

    return (
        <WeightingContainer
            weightingProps={weightingProps}
            events={weightingEvents}
        />
    );
}
